import React from 'react';
import { styled, css, useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

export interface IEllipsis extends IIcon {
  direction?: 'vertical' | 'horizontal';
}

const Svg = styled.svg`
  ${({ direction }) =>
    direction === 'horizontal' &&
    css`
      transform: rotate(90deg);
    `}
`;

const Icon = React.forwardRef<SVGSVGElement | null, IEllipsis>(function Icon(
  { size = 16, alt, color, className, onClick, direction },
  ref,
) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <Svg
      ref={ref}
      viewBox='0 0 16 16'
      onClick={onClick}
      width={size}
      height={size + 1.5}
      className={className}
      fill={fillColor}
      direction={direction}>
      <g>
        <rect fill='none' height='402' width='582' y='-1' x='-1' />
      </g>
      <g>
        <path d='m7.95,11c-0.4,0.01 -0.77,0.18 -1.04,0.48c-0.27,0.29 -0.42,0.67 -0.4,1.07c0.01,0.4 0.18,0.77 0.48,1.05c0.27,0.26 0.63,0.4 1.01,0.4c0.02,0 0.04,0 0.05,0c0.4,-0.01 0.77,-0.18 1.04,-0.48c0.27,-0.29 0.42,-0.67 0.4,-1.08s-0.18,-0.77 -0.48,-1.04c-0.28,-0.27 -0.66,-0.42 -1.06,-0.4zm0.55,1.48c0,0.13 -0.04,0.26 -0.13,0.36c-0.1,0.1 -0.22,0.16 -0.35,0.16c-0.13,0 -0.26,-0.04 -0.36,-0.13c-0.1,-0.09 -0.15,-0.21 -0.16,-0.35c0,-0.13 0.04,-0.26 0.13,-0.36s0.22,-0.16 0.35,-0.16c0.01,0 0.01,0 0.02,0c0.13,0 0.25,0.05 0.34,0.13c0.1,0.1 0.16,0.22 0.16,0.35c0,0 0,0 0,0z' />
        <path d='m8,6.5c-0.83,0 -1.5,0.67 -1.5,1.5s0.67,1.5 1.5,1.5s1.5,-0.67 1.5,-1.5s-0.67,-1.5 -1.5,-1.5zm0,2c-0.28,0 -0.5,-0.22 -0.5,-0.5s0.22,-0.5 0.5,-0.5s0.5,0.22 0.5,0.5s-0.22,0.5 -0.5,0.5z' />
        <path d='m8,5c0.83,0 1.5,-0.67 1.5,-1.5s-0.67,-1.5 -1.5,-1.5s-1.5,0.67 -1.5,1.5s0.67,1.5 1.5,1.5zm0,-2c0.28,0 0.5,0.22 0.5,0.5s-0.22,0.5 -0.5,0.5s-0.5,-0.22 -0.5,-0.5s0.22,-0.5 0.5,-0.5z' />
      </g>
    </Svg>
  );
});

export default React.memo(Icon);
